import { Component, Input } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AmandeService } from '../../services/frapper/amande.service';
import { DossierService } from '../../services/frapper/dossier.service';
import { EnrollementService } from '../../services/frapper/enrollement.service';
import { JugementsService } from '../../services/frapper/jugements.service';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { AlertesService } from '../../services/public/alertes.service';
import { SuccessDialogComponent } from '../../widgets/successDialog/success-dialog.component';
import * as $ from 'jquery';
import { DocumentService } from '../../services/frapper/document.service';


@Component({
  selector: 'app-add-action',
  templateUrl: './add-action.component.html',
  styleUrls: ['./add-action.component.scss']
})
export class AddActionComponent {
   @Input() parentModal: BsModalRef;
    isLinear = true;
    FormEnrollement: FormGroup;
    titre: any;
    type: any;
    step: any;
    show_profil_auth: any
    modalRef!: BsModalRef;
    choicedChambre = this.penalService.selectedDossier;
    createDocument: boolean = false; 
    createTag: boolean = false;
    profil:string = "";
   
  
    constructor(private modalService: BsModalService,
                public options: ModalOptions,
                private jugementService: JugementsService,
                private documentService:DocumentService,
                private role: EnrollementService,
                public bsModalRef: BsModalRef,
                private alerte:AlertesService,
                private dossierService: DossierService,
                private ngxService: NgxUiLoaderService,
                private penalService: PenalCourrierService) {
  
      this.titre = options.initialState.titre;
      this.show_profil_auth = options.initialState.show_profil_auth
      this.profil = localStorage.getItem('profil');
      if (this.profil == "JUGE") {
        this.profil = "JUGE CHAMBRE";
      }
    }
  
    closeModal(){
      this.bsModalRef.hide()
    }

  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message);
  }
  
     async onSubmit(form: NgForm){
  
      if (form.valid) {
        this.ngxService.start();
       
        let body_content ={
         "titre": this.titre,
         "create_document": this.createDocument,
         "create_tag": this.createTag,
         "profil_authoriser": this.profil
      }
  
      //console.log({'bodycontent': body_content});
      try {
        await this.documentService.newAction(body_content).then(res =>{
          if (res != null) {
            this.alerte.successNotification('Nouvelle action','Enregistrement éffectué !')

          }else{
            this.alerte.errorNotification("","Erreur lors de l'enregistrement")
          }

          this.closeWithMessage("success")
        },err =>{
          console.log(err)
          this.alerte.errorNotification('Nouvelle action','Erreur lors de l\'enregistrement !')
          this.ngxService.stop()
        })
      } catch (error) {
        this.alerte.errorNotification("","Erreur lors de l'enregistrement")
      }
        
  
      this.ngxService.stop()
      } else {
        this.ngxService.stop();
        console.log('Form is invalid. Cannot submit.');
      }
  
    }
  
    initializeStepper() {
      console.log('innnnn ssteppp 31  '+this.type );
      var stepFirst = this.type;
  
      $(document).ready(function(){
        var current_fs, next_fs, previous_fs; //fieldsets
        var opacity;
        var current = 1;
        var steps = $("fieldset").length;
  
  
        setProgressBar(current);
  
  
  
  
  
  
        // Fonction pour définir la barre de progression
        function setProgressBar(curStep){
            var percent = (100 / steps) * curStep;
            percent = percent
            $(".progress-bar").css("width",percent+"%");
        }
  
        // Logique pour passer à l'étape suivante
        $(".next").click(function(){
           
  
            // Afficher le fieldset suivant avec une animation
            // if (this.numero_jugement != null) {
              current_fs = $(this).parent();
              next_fs = $(this).parent().next();
    
              // Ajouter la classe "active" à l'étape suivante de la barre de progression
              $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
              next_fs.show();
              current_fs.animate({opacity: 0}, {
                step: function(now) {
                    opacity = 1 - now;
                    current_fs.css({
                        'display': 'none',
                        'position': 'relative'
                    });
                    next_fs.css({'opacity': opacity});
                },
                duration: 500
            });
            setProgressBar(++current);
            // }
           
            
        });
  
        // Logique pour revenir à l'étape précédente
        $(".previous").click(function(){
            current_fs = $(this).parent();
            previous_fs = $(this).parent().prev();
  
            // Retirer la classe "active" de l'étape actuelle de la barre de progression
            $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
  
            // Afficher le fieldset précédent avec une animation
            previous_fs.show();
            current_fs.animate({opacity: 0}, {
                step: function(now) {
                    opacity = 1 - now;
                    current_fs.css({
                        'display': 'none',
                        'position': 'relative'
                    });
                    previous_fs.css({'opacity': opacity});
                },
                duration: 500
            });
            setProgressBar(--current);
        });
    });
  
  
  
    }
  
    ngOnInit() {
  
     this.initializeStepper()
    }
}
